/** PORTAL-4303 Remove if not needed */
import React, { useState } from 'react';
import Container from '@boschebike/ebds-react/dist-esm/components/Container.js';
import Checkbox from '@boschebike/ebds-react/dist-esm/components/Checkbox.js';
import Button from '@boschebike/ebds-react/dist-esm/components/Button.js';
import ModalSheet from '@boschebike/ebds-react/dist-esm/components/ModalSheet.js';
import { IconAsChunk } from '@boschebike/ebds-react-icons';

const EnableServiceModalSheet = ({
  dispatchHide,

  // headline of modal sheet
  headline,

  // service info (name, description and image)
  serviceName,
  serviceDescription,
  serviceImageUrl,
  serviceImageWidth,
  serviceImageHeight,

  // tnc box text (headline, checkbox, confirm and cancel)
  tncHeadline,
  tncCheckbox,
  tncConfirm,
  tncCancel,

  // user brands
  brandList,
  brandsDescription,

  // callbacks
  onConfirm,
}) => {
  const [consent, setConsent] = useState(false);
  const mappedBrands = brandList.map((bi, i) =>
    brandList.length - 1 == i ? (
      <strong>{bi}</strong>
    ) : (
      <>
        <strong>{bi}</strong>,{' '}
      </>
    ),
  );

  return (
    <ModalSheet.Content type="gooseEnableService">
      <Container customContentClassName="goose-modal-enable-service">
        <h3>{headline}</h3>
        <div
          data-testid="modal-enable-service-info"
          className="goose-modal-enable-service__service-info"
        >
          <img
            src={serviceImageUrl}
            alt=""
            width={serviceImageWidth}
            height={serviceImageHeight}
          />
          <div
            data-testid="modal-enable-service-info-details"
            className="goose-modal-enable-service__service-info__details"
          >
            <h4>{serviceName}</h4>
            <p>{serviceDescription}</p>
          </div>
        </div>
        <div
          data-testid="modal-enable-service-consent-container"
          className="goose-modal-enable-service__consent-container"
        >
          <div
            data-testid="modal-enable-service-consent-container-tnc"
            className="goose-modal-enable-service__consent-container__tnc"
          >
            <strong>{tncHeadline}</strong>
            <div
              data-testid="modal-enable-service-consent-container-tnc-checkbox"
              className="goose-modal-enable-service__consent-container__tnc__checkbox"
            >
              <Checkbox
                name="goose-enable-service-consent"
                id="goose-enable-service-consent"
                checked={consent}
                onChange={() => setConsent(!consent)}
              />
              <span dangerouslySetInnerHTML={{ __html: tncCheckbox }} />
            </div>
          </div>

          <div
            data-testid="modal-enable-service-consent-container-footer"
            className="goose-modal-enable-service__consent-container__footer"
          >
            <div
              data-testid="modal-enable-service-consent-container-footer-brands"
              className="goose-modal-enable-service__consent-container__footer__brands"
            >
              <p>
                {brandsDescription} <br /> {mappedBrands}
              </p>
            </div>

            <div
              data-testid="modal-enable-service-consent-container-footer-buttons"
              className="goose-modal-enable-service__consent-container__footer__buttons"
            >
              <Button
                name="goose-enable-service-confirm"
                id="goose-enable-service-confirm"
                type="button"
                mode="primary"
                state={consent ? 'normal' : 'disabled'}
                text={tncConfirm}
                srText={tncConfirm}
                onClick={() => onConfirm()}
              />
              <Button
                name="goose-enable-service-cancel"
                id="goose-enable-service-cancel"
                type="button"
                mode="tertiary"
                state="normal"
                icon={<IconAsChunk iconName="CloseSmall" />}
                text={tncCancel}
                srText={tncCancel}
                onClick={() => dispatchHide()}
              />
            </div>
          </div>
        </div>
      </Container>
    </ModalSheet.Content>
  );
};

export default EnableServiceModalSheet;
